import React, { useState } from 'react';

import { Switch } from 'antd';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { timeArrayToString, timeStringToArray, getTime, isSameDate } from '@libs/NwMoment';
import { getEndTime } from '@libs/NwUtils';

import CustomDatePicker from '@components/EventDateTimePicker/CustomDatePicker';
import TimePicker from '@components/EventDateTimePicker/TimePicker';
import FlexContainer from '@components/Gui/FlexContainer';

const EndDateContainer = styled.div`
    .disabled-end-date {
        background: #d9d9d9;
        opacity: 0.7;
    }
`;

const CheckAllDay = styled.div`
    white-space: nowrap;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;

    label {
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
        text-transform: uppercase;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }

    .start-date {
        flex: 1;
    }
    .end-date {
        flex: 1;
    }

    .date-picker-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 0.5rem;
        min-width: 25rem;

        &.no-min-width {
            min-width: 0;
        }

        @media (max-width: 768px) {
            min-width: 0;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 0.5rem;
        }
    }

    .end-date-picker-wrapper {
        flex: 1;
        .disabled-end-date {
            background: #d9d9d9;
            opacity: 0.7;
        }
    }

    .all-day {
        white-space: nowrap;
    }
`;

const LongEventPeriodPicker = ({ value, singleDay, onChange }) => {
    const { startDate, endDate, startTime, endTime, allDay } = value;
    const [disableEndDate, setDisableEndDate] = useState(true);

    const handleUpdateStartDate = (date) => {
        onChange({
            ...value,
            startDate: date,
            endDate: date, //newEndDate
            dates: [
                {
                    date: date,
                    optionNumber: null,
                },
            ],
        });
        if (!disableEndDate) {
            setDisableEndDate(true);
        }
    };

    const handleChangeStartTime = (time) => {
        const endTimeVal = getEndTime(startTime, endTime, timeStringToArray(time));
        onChange({
            ...value,
            startTime: timeStringToArray(time),
            endTime: [parseInt(endTimeVal / 60), endTimeVal % 60],
        });
    };

    const handleChangeEndTime = (time) => {
        onChange({
            ...value,
            endTime: timeStringToArray(time),
        });
    };

    const handleClickEndDate = () => {
        if (disableEndDate) {
            setDisableEndDate(false);
        }
    };

    const handleUpdateEndDate = (date) => {
        let newValue = {
            ...value,
            endDate: date,
        };
        if (isSameDate(startDate, date)) {
            let endTimeVal = startTime[0] * 60 + startTime[1] + 120; // endtime = starttime + 2 hours;
            endTimeVal = endTimeVal >= 1440 ? 1439 : endTimeVal;
            newValue.endTime = [parseInt(endTimeVal / 60), endTimeVal % 60];
        }
        onChange(newValue);
    };

    const handleSetAllDay = (checked) => {
        if (checked) {
            onChange({
                ...value,
                allDay: checked,
                startTime: [0, 0],
                endTime: [23, 59],
            });
        } else {
            onChange({
                ...value,
                allDay: checked,
                startTime: [9, 0],
                endTime: [9, 0],
            });
        }
    };

    const disabledEndDate = (date) => {
        const days = date.diff(startDate, 'days');
        if (days >= 0 && days <= 365) {
            return false;
        }
        return true;
    };

    return (
        <Wrapper>
            <div className="start-date">
                <label>From</label>
                <div className="date-picker-wrapper">
                    <CustomDatePicker
                        label="Start Date"
                        name="startDate"
                        value={startDate}
                        onChange={handleUpdateStartDate}
                    />
                    <Switch checked={allDay} onChange={handleSetAllDay} />
                    <div className="all-day">all day</div>
                    {!allDay && (
                        <TimePicker
                            label="Start Time"
                            name="startTime"
                            disabled={allDay}
                            value={timeArrayToString(startTime)}
                            onChange={handleChangeStartTime}
                        />
                    )}
                </div>
            </div>
            <div className="end-date">
                {(!allDay || !singleDay) && <label>To</label>}
                <div className="date-picker-wrapper no-min-width">
                    {!allDay && (
                        <TimePicker
                            label="End Time"
                            name="endTime"
                            disabled={allDay}
                            beforeTime={isSameDate(startDate, endDate) && timeArrayToString(startTime)}
                            value={timeArrayToString(endTime)}
                            onChange={handleChangeEndTime}
                        />
                    )}
                    {!singleDay && (
                        <div className="end-date-picker-wrapper">
                            <div onClick={handleClickEndDate}>
                                <CustomDatePicker
                                    label="End Date"
                                    name="endDate"
                                    className={disableEndDate && 'disabled-end-date'}
                                    disabledRange={disabledEndDate}
                                    value={endDate}
                                    onChange={handleUpdateEndDate}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Wrapper>
    );
};

export default LongEventPeriodPicker;
